import { Button } from "app/components/button";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { useEmpresa } from "app/contexts";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import {
  CelularesTable,
  CorreosElectronicosTable,
  PaginasWebTable,
  TelefonosTable,
} from "../";
import { Row } from "app/components/row";

export function ContactosTables() {
  const navigate = useNavigate();

  const { empresa } = useEmpresa();

  function handleBack() {
    return navigate("../../establecimientos");
  }

  function handleNext() {
    // if (!empresa.telefonos.length) {
    //   toast.error("Por favor, agregue al menos un número de teléfono.");
    //   return navigate("telefonos/add");
    // }

    if (!empresa.celulares.length) {
      toast.error("Por favor, agregue al menos un número de celular.");

      return navigate("celulares/add");
    } else if (!empresa.correos_electronicos.length) {
      toast.error(
        "Por favor, agregue al menos una direccion de correo electrónico."
      );

      return navigate("correos-electronicos/add");
    }

    return navigate("../../encargados");
  }

  return (
    <Container>
      {/* <Row gutter={5}> */}
      <Row gutter={4}>
        <Column>
          <TelefonosTable />
          <hr />
        </Column>

        <Column>
          <CelularesTable />
          <hr />
        </Column>

        <Column>
          <CorreosElectronicosTable />
          <hr />
        </Column>

        <Column>
          <PaginasWebTable />
          <hr />
        </Column>
      </Row>
      {/* </Row> */}

      <div className="p-4">
        <DFlexResponsive justifyContent="end">
          <Button title="Anterior" color="secondary" onClick={handleBack} />

          <Button title="Siguiente" color="success" onClick={handleNext} />
        </DFlexResponsive>
      </div>
    </Container>
  );
}
